export default function buildLastName(last: string | null, second: string | null) {
  if (last === '') return null;
  if (!second) return last;
  return `${last} ${second}`;
}
